// Template da Meta (lista de /connections/{id}/templates): corpo e nº de parâmetros
// posicionais {{N}}. Usado no follow-up e na aba Portais — um lugar só para quando
// o template ganhar parâmetro nomeado.
export const bodyOf = (t: any): string =>
  String((t?.components ?? []).find((c: any) => c.type === "BODY")?.text ?? "");

export const countSlots = (body: string): number => new Set(body.match(/\{\{\d+\}\}/g) ?? []).size;
